import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProductCard from './ProductCard';
import {
  fetchProductsByCategory,
  mapProductToCard,
} from '../utils/productStorefront';

const TOP_WEAR_CATEGORY = 'top wear';

const PopularCollection = ({ onAddToCart, catalogReady }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!catalogReady) return;
    let cancelled = false;

    const loadTopWear = async () => {
      try {
        const items = await fetchProductsByCategory(TOP_WEAR_CATEGORY);
        if (items.length === 0) return;

        const mapped = await Promise.all(
          items.map((p) => mapProductToCard(p, { withColors: true }))
        );
        if (!cancelled) setProducts(mapped);
      } catch {
        /* API only */
      }
    };

    loadTopWear();
    return () => {
      cancelled = true;
    };
  }, [catalogReady]);

  if (products.length === 0) return null;

  return (
    <section className="py-5">
      <Container>
        <Row className="g-4">
          {products.map((product) => (
            <Col key={product.id} xs={6} sm={6} lg={3} xl={3}>
              <ProductCard
                product={product}
                onAddToCart={onAddToCart}
                textAlign="left"
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default PopularCollection;
